import React from 'react';
import { useParams } from 'react-router';
import { useMutation } from '@apollo/client';
import moment from 'moment';
import { Button } from 'antd';
import { Link } from 'components/layout';
import {
  SUBMIT_REPORT,
  SUBMIT_REPORT_WITH_CUSTOM_DATE,
} from '../../../../../gql/reportSubmissions';
import ScheduledReportSubmissionDetail from './ScheduledReportSubmissionDetail';
import SubmitForm from './SubmitForm';
import { useHasScopeTypeInProject } from '../../../../../hooks';
import { PageContainer } from '@ant-design/pro-layout';
import { getId } from '../../../../../utils';
import useProjectFrozen from 'hooks/useProjectFrozen';

const SubmitReport = ({ reducer: { dispatch } }) => {
  const { id, projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const {
    hasScopeType: canSubmitWithCustomDate,
    loading: submitWithCustomDateLoading,
  } = useHasScopeTypeInProject('SUBMIT_REPORT_WITH_CUSTOM_DATE');
  const { hasScopeType: canSubmit, loading: submitLoading } =
    useHasScopeTypeInProject('SUBMIT_REPORT');
  const { hasScopeType: canEdit, loading: editLoading } =
    useHasScopeTypeInProject('WRITE_SCHEDULED_REPORT_SUBMISSION');
  const [submitReport] = useMutation(
    canSubmitWithCustomDate ? SUBMIT_REPORT_WITH_CUSTOM_DATE : SUBMIT_REPORT,
    {
      refetchQueries: [],
      awaitRefetchQueries: true,
      onCompleted: ({ submitReport: { status } }) => {
        switch (status) {
          case 'REVIEWING':
            dispatch({ type: 'REVIEWING' });
            break;
          case 'COMPLETED':
            dispatch({ type: 'COMPLETED' });
            break;
          default:
            dispatch({ type: 'REVIEWING' });
            break;
        }
      },
    }
  );

  return (
    <PageContainer>
      {canEdit && !projectFrozen && (
        <p>
          <Button type="primary">
            <Link to={`/projects/${projectId}/report-submissions/${id}/edit`}>
              Edit Report Submission Schedule
            </Link>
          </Button>
        </p>
      )}
      <ScheduledReportSubmissionDetail />
      <SubmitForm
        disabled={(!canSubmit && !canSubmitWithCustomDate) || projectFrozen}
        withCustomDate={canSubmitWithCustomDate}
        loading={submitWithCustomDateLoading || submitLoading || editLoading}
        onFinish={async ({ actualSubmissionDate, reportFile, remarks }) => {
          const input = {
            id,
            projectId,
            reportFile: getId(reportFile)[0],
            remarks,
          };
          if (canSubmitWithCustomDate) {
            input.actualSubmissionDate =
              moment(actualSubmissionDate).format('YYYY-MM-DD');
          }
          await submitReport({
            variables: {
              input,
            },
          });
        }}
      />
    </PageContainer>
  );
};

export default SubmitReport;
